/* HS · R'EFECT — Round 3 behaviour (3 Nov 2026). Front-end only, no cart/checkout logic changed. */
(function () {
  'use strict';

  /* ---------- PDP variant rail (c11) ---------- */
  function initVariantRails(root) {
    (root || document).querySelectorAll('[data-hs-vrail]:not([data-hs-ready])').forEach(function (rail) {
      rail.setAttribute('data-hs-ready', '');
      var track = rail.querySelector('.hs-variant-rail__track');
      var prev = rail.querySelector('[data-hs-vrail-prev]');
      var next = rail.querySelector('[data-hs-vrail-next]');
      if (!track) return;
      function upd() {
        var max = track.scrollWidth - track.clientWidth - 2;
        var overflow = max > 0;
        if (prev) prev.hidden = !overflow || track.scrollLeft <= 2;
        if (next) next.hidden = !overflow || track.scrollLeft >= max;
        rail.classList.toggle('is-end', !overflow || track.scrollLeft >= max);
      }
      function by(dir) { track.scrollBy({ left: dir * Math.max(track.clientWidth * 0.7, 120), behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { by(-1); });
      if (next) next.addEventListener('click', function () { by(1); });
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      /* keep the selected value in view */
      var checked = track.querySelector('input:checked + label');
      if (checked) track.scrollLeft = Math.max(0, checked.offsetLeft - track.clientWidth / 2 + checked.clientWidth / 2);
      upd();
    });
  }

  /* ---------- Bundle: guided steps ---------- */
  function initBundles() {
    document.querySelectorAll('[data-hs-bundle]:not([data-hs-ready])').forEach(function (sec) {
      sec.setAttribute('data-hs-ready', '');
      var autoNext = sec.getAttribute('data-hs-auto-next') === 'true';
      var counter = sec.querySelector('.products-bundle-selection__count');
      var tabs = Array.prototype.slice.call(sec.querySelectorAll('.hs-bundle__step'));
      if (!counter || !tabs.length) return;
      var last = parseInt(counter.textContent, 10) || 0;
      var picksByTab = tabs.map(function () { return 0; });

      function activeIndex() {
        for (var i = 0; i < tabs.length; i++) if (tabs[i].classList.contains('active')) return i;
        return 0;
      }
      function paint() {
        tabs.forEach(function (t, i) {
          t.classList.toggle('is-done', picksByTab[i] > 0);
          t.setAttribute('aria-selected', t.classList.contains('active') ? 'true' : 'false');
        });
      }
      /* Hyper toggles .active on click — mirror it to aria-selected */
      tabs.forEach(function (t) { t.addEventListener('click', function () { setTimeout(paint, 0); }); });

      new MutationObserver(function () {
        var n = parseInt(counter.textContent, 10) || 0;
        if (n === last) return;
        var i = activeIndex();
        if (n > last) {
          picksByTab[i] += n - last;
          if (autoNext) {
            /* next step that has no pick yet */
            for (var k = 1; k <= tabs.length; k++) {
              var j = (i + k) % tabs.length;
              if (picksByTab[j] === 0) { setTimeout(function () { tabs[j].click(); }, 350); break; }
            }
          }
        } else {
          /* item removed from the bar: take it off the most recent step with picks */
          var diff = last - n;
          for (var r = tabs.length - 1; r >= 0 && diff > 0; r--) {
            var take = Math.min(picksByTab[r], diff); picksByTab[r] -= take; diff -= take;
          }
        }
        last = n;
        paint();
      }).observe(counter, { childList: true, characterData: true, subtree: true });
      paint();
    });
  }

  /* ---------- Demanded Collections: load every tab image once the section is near, so switching tabs never shows a blank frame ---------- */
  function initDemImages() {
    var imgs = document.querySelectorAll('.hs-dem-img img[loading="lazy"]');
    if (!imgs.length || !('IntersectionObserver' in window)) return;
    var sec = imgs[0].closest('collection-tabs'); if (!sec || sec.hasAttribute('data-hs-dem')) return;
    sec.setAttribute('data-hs-dem', '');
    var io = new IntersectionObserver(function (es) {
      if (!es.some(function (e) { return e.isIntersecting; })) return;
      sec.querySelectorAll('.hs-dem-img img').forEach(function (i) { i.loading = 'eager'; });
      io.disconnect();
    }, { rootMargin: '400px 0px' });
    io.observe(sec);
  }

  /* ---------- Mobile sticky header: search pill collapses to an icon; tap to open it over the bar ---------- */
  function initStickySearch() {
    var btn = document.querySelector('[data-hs-sticky-search]');
    if (!btn || btn.hasAttribute('data-hs-ready')) return;
    btn.setAttribute('data-hs-ready', '');
    var sec = btn.closest('.header-section') || document.querySelector('.header-section');
    if (!sec) return;
    /* only touch the class when it is set — removing an absent class still rewrites the attribute and re-fires the observer */
    function close() { if (sec.classList.contains('hs-search-expanded')) sec.classList.remove('hs-search-expanded'); }
    btn.addEventListener('click', function () {
      sec.classList.add('hs-search-expanded');
      var input = sec.querySelector('.header__search input[type="search"], .header__search input');
      if (input) setTimeout(function () { input.focus(); }, 50);
    });
    sec.addEventListener('click', function (e) { if (e.target.closest('.header__search-close')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    /* collapse when back at the top (full header) or when the header hides on scroll down */
    new MutationObserver(function () {
      if (!sec.classList.contains('header-scrolled') || !document.body.classList.contains('header-pinned')) close();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(function () { if (!sec.classList.contains('header-scrolled')) close(); }).observe(sec, { attributes: true, attributeFilter: ['class'] });
  }

  function init() { initVariantRails(); initBundles(); initDemImages(); initStickySearch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* re-run when Hyper swaps variant/product HTML or the editor reloads a section */
  var q = false;
  new MutationObserver(function () {
    if (q) return; q = true;
    requestAnimationFrame(function () { q = false; initVariantRails(); initBundles(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', init);
})();
